// Helpers Google Ads (AW-18401470430)
// - IDs, send_to, value y currency NUNCA se modifican (vienen tal como los generó Google Ads).
// - Cada helper es idempotente y NO se dispara al cargar la página; solo cuando el usuario ejecuta la acción.
// - Si gtag está bloqueado / tarda / falla, la UX (abrir WhatsApp o agregar al carrito) NUNCA se bloquea.

const GADS_ID = "AW-18401470430";
const CONV_WHATSAPP = `${GADS_ID}/Yg0dCMOTg-YcEN7PwMZE`;
const CONV_ADD_TO_CART = `${GADS_ID}/IL8eCLKGhOYcEN7PwMZE`;

/**
 * Dispara la conversión "Clic WhatsApp - Compra ya" y abre WhatsApp.
 * @param {string} url URL de wa.me a abrir después del tracking.
 * @returns {boolean} false para permitir usarlo como onClick de <a href>.
 */
export function fireWhatsappCompraYaConversion(url) {
  const state = { opened: false };
  const openWhatsapp = () => {
    if (state.opened) return;
    state.opened = true;
    try { window.open(url, "_blank"); } catch { window.location.href = url; }
  };
  // Fallback de seguridad: si gtag no responde en 1s, abrir WhatsApp igualmente.
  const timer = setTimeout(openWhatsapp, 1000);
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: CONV_WHATSAPP,
        event_callback: function () {
          clearTimeout(timer);
          openWhatsapp();
        },
      });
    } else {
      clearTimeout(timer);
      openWhatsapp();
    }
  } catch (_) {
    clearTimeout(timer);
    openWhatsapp();
  }
  return false;
}

/**
 * Dispara la conversión "Inclusión en el carrito" (llamar SOLO tras confirmar que se agregó al carrito).
 * No redirige, no bloquea la UI.
 */
export function fireAddToCartConversion() {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: CONV_ADD_TO_CART,
        value: 1.0,
        currency: "USD",
      });
    }
  } catch (_) { /* silencioso */ }
}
